import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Media } from "../../base-models/media-view";
import { BaseDataService } from "../../base-services/base-data.service";
import { QueryParameter } from "../../base-models/query-parameter";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { CryptoService } from "../../base-services/crypto.service";

@Component({
    selector: 'yt-promo-dialog',
    templateUrl: './promo-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromoDialog{
    constructor(
        private activeModal: NgbActiveModal,
        private baseDataService: BaseDataService,
        private changeDetectorRef: ChangeDetectorRef,
        private sanitizer: DomSanitizer){

        }

    @Input() set path(value: string){
        this.loadMediaInfo(value);
    }

    media: Media = new Media();
    showCloseButton: boolean = false;
    safeVideoUrl: SafeResourceUrl;
    safeImageUrl: SafeResourceUrl;
    videoAvailable: boolean = false;
    close(){
        this.activeModal.dismiss();
    }

    private loadMediaInfo(path: string){
        this.baseDataService.Get('Media', 'getByMenuUrl', [ new QueryParameter('menuUrl', path) ], Media)
            .subscribe((data: any) => {
                this.media = data;
                if (this.media.VideoId) {
                    this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${this.media.VideoId}`);
                    this.videoAvailable = true;
                } else {
                    this.safeImageUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/images/video-u-pripremi.png'); 
                    this.videoAvailable = false;
                }
                this.changeDetectorRef.markForCheck();
            })
    }

    linkClicked(){
        const actionUrl = this.media.ActionUrl.endsWith('/') ? this.media.ActionUrl.slice(0,-1) : this.media.ActionUrl;

        var decryptedUser: any = null;
        var decryptedOrgJed: any = null;
        try { 
            decryptedUser = CryptoService.Decrypt(sessionStorage.getItem('sel-user')); 
            decryptedOrgJed = CryptoService.Decrypt(sessionStorage.getItem('sel-org-jed')); 

        } catch (e) {
            decryptedUser = null; 
            decryptedOrgJed = null;
        }
        
        let paramForUrl: string = "";
        if (decryptedUser && decryptedOrgJed)
        {
            const userName: string = encodeURIComponent((decryptedUser.Username || '').trim());
            const firmaNaziv: string = encodeURIComponent((decryptedOrgJed.FirmaNaziv || '').trim());
            const naslov = encodeURIComponent((this.media.Naziv || '').trim());

            paramForUrl = '?firmanaziv=${firmaNaziv}&username=${userName}&naslov=${naslov}';
        }

        window.open(actionUrl + paramForUrl, '_blank')?.focus();
    }
}